import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What industries do you primarily work with?",
      answer: "We partner with ambitious SMEs across real estate, ed-tech, e-commerce, hospitality, healthcare, and logistics. Our agile development processes are built to adapt—if we can add technical value and drive revenue growth for your company, we are fully equipped to build it regardless of the sector."
    },
    {
      question: "What is your development methodology?",
      answer: "We utilize an iterative Agile development methodology. This means you will see real, functional software updates every 1 to 2 weeks. Regular feedback loops, collaborative sprints, and rigorous continuous testing ensure that your final product aligns perfectly with your business goals."
    },
    {
      question: "How long does a typical project take?",
      answer: "Timelines depend entirely on the complexity and scope of your platform. A custom MVP (Minimum Viable Product) or premium web application typically takes between 4 to 8 weeks. We provide a transparent, milestone-by-milestone breakdown during our discovery phase so you know exactly what to expect."
    },
    {
      question: "How much does it cost to build a website or application?",
      answer: "Every digital solution we architect is custom-built for maximum scalability. Pricing depends on your specific technical requirements, third-party integrations, and team structure. Contact us for a precise, breakdown-driven quotation customized for your business parameters."
    },
    {
      question: "Do you provide post-launch support and maintenance?",
      answer: "Yes. Technology requires continuous optimization. We offer comprehensive support, monitoring, and scale management packages. From server health monitoring and security patches to minor feature deployments, we keep your business operational and secure 24/7."
    },
    {
      question: "Can you help migrate or scale our existing codebase?",
      answer: "Absolutely. Whether you need to transition a legacy system to a modern tech stack (like React, Node.js, or Laravel) or optimize your cloud setup on AWS to handle massive increases in active user traffic, our team can audit, refactor, and future-proof your digital infrastructure."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="container">
        <h2 className="section-title">
          Frequently Asked <span className="gradient-text">Questions</span>
        </h2>
        <p className="section-subtitle">Everything you need to know about partnering with xcotech</p>
        
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="faq-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              viewport={{ once: true }}
            >
              <button 
                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              
              <AnimatePresence initial={false}>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25, ease: 'easeInOut' }}
                    className="faq-answer"
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;